import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function DateRangePicker({ dateRange, setDateRange, popperPlacement = "bottom-start" ,theme="dark"}) {
  return (
    <div className="flex space-x-2">
      <div className="flex-1 ">
        <label className="block text-xs dark:text-gray-400 text-textSecondary mb-1">From:</label>
        <DatePicker
          selected={dateRange[0]}
          onChange={(date) => {
            if (date && dateRange[1] && date > dateRange[1]) {
              return;
            }
            setDateRange([date, dateRange[1]]);
          }}
          selectsStart
          startDate={dateRange[0]}
          endDate={dateRange[1]}
          className="w-44 dark:glass-effect border border-gray-600 rounded-full px-3 !py-[5px]  dark:!text-[#EDEDEDE5] !text-textSecondary text-sm focus:outline-none dark:focus:border-white focus:border-gray-400 dark:bg-gray-800 bg-bgPrimary placeholder:text-sm "
          popperClassName={theme === "dark" ? "dark-theme-datepicker" : 'light-theme-datepicker'}
          dateFormat="dd-MM-yyyy"
          placeholderText="Select start date"
          popperPlacement={popperPlacement}
        />
      </div>
      <div className="flex-1">
        <label className="block text-xs dark:text-gray-400 text-textSecondary mb-1">To:</label>
        <DatePicker
          selected={dateRange[1]}
          onChange={(date) => {
            if (date && dateRange[0] && date < dateRange[0]) {
              // Prevent "To" date from being before "From" date
              return;
            }
            setDateRange([dateRange[0], date]);
          }}
          selectsEnd
          startDate={dateRange[0]}
          endDate={dateRange[1]}
          className="w-44 dark:glass-effect border border-gray-600 rounded-full px-3 !py-[5px]  dark:!text-[#EDEDEDE5] !text-textSecondary text-sm focus:outline-none dark:focus:border-white focus:border-gray-400 dark:bg-gray-800 bg-bgPrimary placeholder:text-sm"
         popperClassName={theme === "dark" ? "dark-theme-datepicker" : "light-theme-datepicker"}
          dateFormat="dd-MM-yyyy"
          placeholderText="Select end date"
          popperPlacement={popperPlacement}
          z-index={2000}
        />
      </div>
      <style jsx>{`
        .dark-theme-datepicker {
          z-index: 999999 !important;
        }
          .dark-theme-datepicker,
          .light-theme-datepicker {
            overflow: visible !important;
          }

        .dark-theme-datepicker .react-datepicker {
          background-color: #1f2937;
          border: 1px solid #4b5563;
          border-radius: 0.5rem;
          color: #e5e7eb;
          z-index: 1000;
        }
        .dark-theme-datepicker .react-datepicker__header {
          background-color: #374151;
          border-bottom: 1px solid #4b5563;
          color: #e5e7eb;
        }
        .dark-theme-datepicker .react-datepicker__current-month,
        .dark-theme-datepicker .react-datepicker__day-name,
        .dark-theme-datepicker .react-datepicker__day {
          color: #e5e7eb;
        }
        .dark-theme-datepicker .react-datepicker__day:hover {
          background-color: #6d42b9;
          border-radius: 1rem;
        }
        .dark-theme-datepicker .react-datepicker__day--selected,
        .dark-theme-datepicker .react-datepicker__day--in-range {
          background-color: #6d42b9;
          color: #ffffff;
          border-radius: 1rem;
        }
        .dark-theme-datepicker .react-datepicker__day--today {
          background-color: #10b981;
          color: #ffffff;
          border-radius: 1rem;
        }
        .dark-theme-datepicker .react-datepicker__day--outside-month {
          color: #6b7280;
        }
        .dark-theme-datepicker .react-datepicker__navigation-icon::before {
          border-color: #e5e7eb;
        }
        .dark-theme-datepicker .react-datepicker__triangle {
          border-bottom-color: #374151;
        }
        .dark-theme-datepicker .react-datepicker__triangle::before {
          border-bottom-color: #4b5563;
        }
        .light-theme-datepicker {
          z-index: 999999 !important;
        }

        .light-theme-datepicker .react-datepicker {
          background-color: rgb(var(--bg-primary)); /* White bgPrimary */
          border: 1px solid rgb(var(--text-secondary)); /* Light gray border */
          border-radius: 0.5rem;
          color: #525252  ; /* text-secondary */
          box-shadow: 0 4px 20px rgba(0,0,0,0.08);
        }

        .light-theme-datepicker .react-datepicker__header {
          background-color: rgb(var(--bg-secondary)); /* Light bgSecondary */
          border-bottom: 1px solid rgb(var(--text-secondary));
          color: rgb(var(--text-primary));
        }

        .light-theme-datepicker .react-datepicker__current-month,
        .light-theme-datepicker .react-datepicker__day-name,
        .light-theme-datepicker .react-datepicker__day {
          color: rgb(var(--text-primary)); /* textPrimary */
        }

        .light-theme-datepicker .react-datepicker__day:hover {
          background-color: rgba(64, 113, 255, 0.15); /* heading color fade */
          border-radius: 1rem;
        }

        .light-theme-datepicker .react-datepicker__day--selected,
        .light-theme-datepicker .react-datepicker__day--in-range {
          background-color: rgb(var(--text-heading)); /* blue → heading color */
          color: #525252;
          border-radius: 1rem;
        }

        .light-theme-datepicker .react-datepicker__day--today {
          background-color: rgba(64, 113, 255, 0.25);
          color: rgb(var(--text-heading));
          border-radius: 1rem;
          font-weight: 600;
        }

        .light-theme-datepicker .react-datepicker__day--outside-month {
          color: rgba(0, 0, 0, 0.25); /* faded for other months */
        }

        .light-theme-datepicker .react-datepicker__navigation-icon::before {
          border-color: rgb(var(--text-secondary));
        }

        .light-theme-datepicker .react-datepicker__triangle {
          border-bottom-color: rgb(var(--bg-secondary));
        }

        .light-theme-datepicker .react-datepicker__triangle::before {
          border-bottom-color: rgb(var(--text-secondary));
        }

      `}</style>
    </div>
  );
}

export default DateRangePicker;
